// Structured data (Schema.org) generators for SEO

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Minchio Brothers Productions",
  "url": "https://minchiobrothers.au",
  "logo": "https://minchiobrothers.au/logo.png",
  "description": "Award-winning videography and photography services for Real Estate, Commercial, and Social Media in Australia.",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "AU",
    "addressRegion": "Australia"
  },
  "sameAs": [
    "https://www.instagram.com/minchiobrothers"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "Customer Service",
    "email": "media@matthewminchio.com"
  }
});

export const getLocalBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://minchiobrothers.au",
  "name": "Minchio Brothers Productions",
  "image": "https://minchiobrothers.au/logo.png",
  "description": "Professional real estate photography and videography services in Australia",
  "url": "https://minchiobrothers.au",
  "telephone": "+61-XXX-XXX-XXX",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "AU"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": -33.8688,
    "longitude": 151.2093
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      "opens": "09:00",
      "closes": "18:00"
    }
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "150"
  }
});

export const getServiceSchema = (serviceName, description, price) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": serviceName,
  "provider": {
    "@type": "Organization",
    "name": "Minchio Brothers Productions"
  },
  "description": description,
  "areaServed": {
    "@type": "Country",
    "name": "Australia"
  },
  "offers": {
    "@type": "Offer",
    "price": price,
    "priceCurrency": "AUD"
  }
});

export const getBreadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": `https://minchiobrothers.au${crumb.path}`
  }))
});

export const getWebPageSchema = (title, description, url) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": title,
  "description": description,
  "url": url,
  "publisher": {
    "@type": "Organization",
    "name": "Minchio Brothers Productions"
  }
});

export const getVideoObjectSchema = (name, description, thumbnailUrl, uploadDate, duration) => ({
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "name": name,
  "description": description,
  "thumbnailUrl": thumbnailUrl,
  "uploadDate": uploadDate,
  "duration": duration,
  "contentUrl": "https://minchiobrothers.au"
});

export const getReviewSchema = (reviews) => ({
  "@context": "https://schema.org",
  "@type": "Review",
  "itemReviewed": {
    "@type": "LocalBusiness",
    "name": "Minchio Brothers Productions"
  },
  "reviewRating": {
    "@type": "Rating",
    "ratingValue": reviews.rating,
    "bestRating": "5"
  },
  "author": {
    "@type": "Person",
    "name": reviews.author
  },
  "reviewBody": reviews.text
});
